import { render, staticRenderFns } from "./OaoContainer.vue?vue&type=template&id=347b8fea&scoped=true&functional=true"
import script from "./OaoContainer.vue?vue&type=script&lang=js"
export * from "./OaoContainer.vue?vue&type=script&lang=js"
import style0 from "./OaoContainer.vue?vue&type=style&index=0&id=347b8fea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_0d1d51ab4c56f75a7402f3cb98fb63e0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "347b8fea",
  null
  
)

export default component.exports